import { Component, HostListener, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { Location, isPlatformBrowser } from '@angular/common';
//MODELS
import { AlertBanner } from 'node_modules/ascedia-design-system/lib/models/alert-banner.interface'
import { Hyperlink } from 'ascedia-design-system/lib/models/hyperlink.interface';
import { ConfigService } from './shared/services/config.service';
import { Observable, of } from 'rxjs';
import { map, tap, filter, switchMap, mergeMap, catchError, timeout, finalize } from 'rxjs/operators';
import { MockAPIProvider } from './shared/services/mock-api.provider';
import { Cart } from './shared/models/cart.interface';
import { CartService } from './shared/services/cart.service';
import { AccountInfo, BrowserUtils, InteractionStatus, ServerError, RedirectRequest } from '@azure/msal-browser';
import { MsalBroadcastService, MsalCustomNavigationClient, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { AuthHandlerService } from './auth/auth-handler.service';
import { TravelAdvisorPositionEnum, UserRolesEnum } from './shared/models/user-roles-enum';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import _startsWith from 'lodash-es/startsWith';
import _find from 'lodash-es/find';
import _forEach from 'lodash-es/forEach';
import _remove from 'lodash-es/remove';
import { apiConfig, b2cPolicies } from './auth/b2c-config';
import { StorageService } from './shared/services/storage.service';
import { TravelBoardComponent } from './shared-components/travel-board/travel-board.component';
import { CompassAPIExcursionItineraryService } from './shared/api-compass/compass-api-excursion-itinerary.service';
import { CompassAPIUsersService } from './shared/api-compass/compass-api-users.service';
import { CompassApiResponse } from './shared/models/compass-api-response.interface';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	title = 'CompassTours';

	activeAccountInfo$: Observable<AccountInfo>;
	public activeAccountRole$: Observable<UserRolesEnum>;
	public activeAccountTravelAdvisorPosition$: Observable<TravelAdvisorPositionEnum>;
	
	public isIframe = false;
	public activeAccountInfo: AccountInfo;
	public activeAccountRole: UserRolesEnum;

	public navItems: Hyperlink[];
	
	public alertBanner: AlertBanner;
	public previewBanner: AlertBanner;

	public alertBanner$: Observable<AlertBanner>;
	public previewBanner$: Observable<AlertBanner>;

	public cart$: Observable<Cart>;
	private authInfo$: Observable<AccountInfo> = this._msalBroadcastService.inProgress$
		.pipe(
			filter((status: InteractionStatus) => status === InteractionStatus.None), 
			switchMap(x => this._authHandlerService.activeAccountInfo$)
		);

	@ViewChild(TravelBoardComponent)travelBoardComponent:TravelBoardComponent;

	constructor (
		private _compassAPIExcursionItineraryService: CompassAPIExcursionItineraryService,
		private _compassApiUserService: CompassAPIUsersService,
		private _cartService: CartService,
		private _configService: ConfigService,
		private _mockAPIProvider: MockAPIProvider,
		private _authHandlerService: AuthHandlerService,	
		private _msalBroadcastService: MsalBroadcastService,
		@Inject(MSAL_GUARD_CONFIG) private _msalGuardConfig: MsalGuardConfiguration,
		private authService: MsalService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		location: Location,
		private _storageService: StorageService,
		@Inject(PLATFORM_ID) private platformId: Object,
	) {		
		
		
		const customNavigationClient = new MsalCustomNavigationClient(this.authService, router, location);
		this.authService.instance.setNavigationClient(customNavigationClient);
		this.watchCart()
		this.getAlertBanner();
		router.events
			.pipe(
				filter(e => e instanceof NavigationEnd),
				map(() => this.activatedRoute),
				map(route => {
					while (route.firstChild) route = route.firstChild;
					return route;
				}),
				filter(route => route.outlet === 'primary'),
				mergeMap(route => route.data)
			)
			.subscribe(data => {	
				if (data.azureb2c) {
					this.navItems = this._configService.MainMenuNavItemsAzureb2c;
				}
			});
		this.navItems = this._configService.MainMenuNavItems;
		const accountItems = _find(this.navItems, { 'title':'Account'});
		//console.log('navItems:', this.navItems);
		//console.log('accountItems:', accountItems);
		const signInItem = _find(accountItems.children, { 'title':'Sign In'});
		// console.log('signInItem:', signInItem);
		if (signInItem) {
			signInItem.clickCallback = () => {			
				let userFlowRequest = {
					scopes: apiConfig.scopes,
					authority: b2cPolicies.authorities.signUpSignIn.authority
				};
				if (this._msalGuardConfig.authRequest){
					this.authService.loginRedirect({...this._msalGuardConfig.authRequest, ...userFlowRequest, extraQueryParameters: {
						cart: JSON.stringify(this._storageService.getCart())
					}} as RedirectRequest);
				} else {
					this.authService.loginRedirect();
				}

				return false;
			};
		}
		const signUpItem = _find(accountItems.children, { 'title':'Create Account'});
		// console.log('signUpItem:', signUpItem);
		if (signUpItem) {
			signUpItem.clickCallback = () => {			
				let userFlowRequest = {
					scopes: apiConfig.scopes,
					authority: b2cPolicies.authorities.signUp.authority
				};
				if (this._msalGuardConfig.authRequest){
					this.authService.loginRedirect({...this._msalGuardConfig.authRequest, ...userFlowRequest });
				} else {
					this.authService.loginRedirect();
				}

				return false;
			};
		}
	}

	ngOnInit(): void {
		this.activeAccountInfo$ = this._authHandlerService.activeAccountInfo$;
		this.activeAccountRole$ = this._authHandlerService.activeAccountRole$;
		this.activeAccountTravelAdvisorPosition$ = this._authHandlerService.activeAccountTravelAdvisorPosition$;

		this.authService.handleRedirectObservable().subscribe({
			next: (result) => {},
			error: (error) => {
				const serverError = error as ServerError;
				if (serverError) {
					if (_startsWith(serverError.errorMessage, 'AADB2C90118')) {
						this.forgotPassword();
					}
				}
			}
		  });
		this.authInfo$.subscribe(authInfo=> {
			if(authInfo) {
				//alert('is logged in');				
				this._compassAPIExcursionItineraryService.getLatestBoard(authInfo.localAccountId)
					.then((res) => {
						//console.log('getLatestBoard:', res);
					})
					.catch((err) => {
						//console.log('getLatestBoard.err:', err);
					});

				if (authInfo.idTokenClaims['newUser']) {
					window['dataLayer'].push({
						'event': 'create_account'});
						// authInfo.localAccountId (or ) authInfo.username
					this._compassApiUserService.addToHubspot(authInfo.localAccountId).pipe(
						catchError(err => of({"error": err.error})))
						.subscribe();
				} else {
					window['dataLayer'].push({
						'event': 'login'});
						//this._cartService.loadCart();
				}
			}
			const accountItem = _find(this.navItems, { 'title':'Account'});
			//console.log('accountItem:', accountItem);
			if (accountItem && authInfo != null) {
				_remove(accountItem.children, (item) => item.title == 'Create Account');
				accountItem.title = authInfo.name;
				accountItem.children = this._configService.mainNavSignedInMenuItems;
				const signOutItem = _find(accountItem.children, { 'title':'Sign Out'});
				signOutItem.clickCallback = () => {		
					console.log('signOutItem.clickCallback:', authInfo);//TODO: CALL LAST VISISTED
					this._compassApiUserService.updateLastVisited(window.location.href).pipe(
						timeout(500),
						catchError(err => {
							console.log('updateLastVisited.err:', err);
							return of(null);
						}),
						finalize(() => {
							this.authService.logoutRedirect();
							this._storageService.signOut();
						}))
						.subscribe();
					// this.authService.logoutRedirect();
					// this._storageService.signOut();		
					return false;
				};
			}
		});
		this.isIframe = typeof window !== "undefined" && (BrowserUtils.isInIframe() || BrowserUtils.isInPopup());	

		this.router.events.forEach(item => {
			if (item instanceof NavigationEnd) {
				//console.log('app.routerChange:', item);
				const isAddToBoard = item.url.toLowerCase().includes('addtoboard');
				//console.log('isAddToBoard:', isAddToBoard, window.location.hash);
				if(isAddToBoard) {
					this.travelBoardComponent.onAddToBoard();
				} else {
					if(isPlatformBrowser(this.platformId)) {
						this._compassApiUserService
							.updateLastVisited(window.location.href)
							.subscribe({
									error: err =>
											console.error('Failed to save last visited page:', err)
							});
						window.scroll(0, 0);
					}
				}
			}	
		});
	}

	forgotPassword() {
		let forgotFlowRequest = {
			scopes: apiConfig.scopes,
			authority: b2cPolicies.authorities.forgotPassword.authority,
		};
		if (this._msalGuardConfig.authRequest){
			this.authService.loginRedirect({...this._msalGuardConfig.authRequest, ...forgotFlowRequest} as RedirectRequest);
		} else {
			this.authService.loginRedirect();
		}
	}

	public getAlertBanner() {
		this.alertBanner$ = this._mockAPIProvider.load('main/banner-alert.json', true)
			.pipe(map((res: AlertBanner) => {
				//console.log('alertBanner$:', res);
				if(res) {
					return res;
				}
				return null;
			}));

		this.previewBanner$ = this._mockAPIProvider.load('main/banner-preview.json', true)
			.pipe(map((res: AlertBanner) => {
				//console.log('previewBanner$:', res);
				if(res) {
					return res;
				}
				return null;
			}));

	}


	
	public watchCart() {
		//console.log('app.watchCart()');
		this.cart$ = this._cartService.cart$
			.pipe(tap((data: any) => {
				//console.log('app.watchCart.cart$:', data);
				this.processCart(data);
			}));

	}



	public processCart(cart: Cart){
		// cart?.items.forEach(item => {
		// 	console.log('app.item:', item);
		// });
		const badge = (cart?.items && cart?.items.length > 0) ? cart.items.length : null;
		this._configService.updateCartBadge(badge);
	}
}
